import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";

function Aboutpage() {
  return (
    <div className="aboutpagebackground">
      <Container>
        <Row className="textbackground">
          <Col md={7}>
            <h3 className="aboutmetext">
              About <span>Me</span>
            </h3>
            <p className="aboutdetails">
              I am a creative, dependable, and enthusiastic person in my work. I
              enjoy seeking creative solutions and always commit to delivering
              high-quality results. My enthusiasm and passion will help me
              succeed in all areas of life.
            </p>
            <ul className="skilllist">
              <Row>
                <h3>Skills</h3>
                <Col sx={12}>
                  <li>Marketing</li>
                  <li>Product</li>
                  <li>Technical Skill</li>
                </Col>
              </Row>
            </ul>
          </Col>
          <Col md={5}>
            <div className="webimage"></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Aboutpage;
